module.exports = __webpack_public_path__ + "static/media/catchement.eda0b1c2.svg";